import React from "react";
import Button from "components/CustomButton";
import * as microsoftTeams from "@microsoft/teams-js";

const styles = {
  audioRecorder: {
    maxWidth: "80vw",
    backgroundColor: "#999999",
  },
  recoderButton: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default ({ onChange = () => {} }) => {
  const classes = styles;

  const displayteamsRecorder = () => {
    microsoftTeams.app.initialize().then(() => {
      const audioProps = {
        maxDuration: 1,
      };
      
      const microsoftConstraint = {
        maxMediaCount: 1,
        mediaType: microsoftTeams.media.MediaType.Audio,
        audioProps: audioProps,
      };

      microsoftTeams.media.selectMedia(microsoftConstraint)
        .then((attachments) => {
          if (attachments && attachments.length > 0) {
            const audioResult = attachments[0];
            audioResult.content.getReader().read()
              .then(({ value }) => {
                if (value) {
                  const blob = new Blob([value], { type: "audio/webm" });
                  const audio_output = new File(
                    [blob],
                    `${new Date().getTime()}.webm`,
                    {
                      type: "audio/webm",
                    }
                  );
                  onChange(audio_output);
                }
              })
              .catch((error) => {
                console.log("Error reading audio content:", error);
              });
          }
        })
        .catch((error) => {
          console.log("Error selecting media:", error);
        });
    });
  };

  return (
    <div style={classes.audioRecorder}>
      <div style={classes.recoderButton}>
        <Button
          buttonClass={"RecorderDialogButton androidRecordingButton"}
          onClick={displayteamsRecorder}
        >
          Click to play audio
        </Button>
      </div>
    </div>
  );
};
